/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_A11Inputs */

const en_cv_extract_form_enum_a11 = /** @type {(inputs: Cv_Extract_Form_Enum_A11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A1 - Beginner`)
};

const de_cv_extract_form_enum_a11 = /** @type {(inputs: Cv_Extract_Form_Enum_A11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A1 - Anfänger`)
};

/**
* | output |
* | --- |
* | "A1 - Beginner" |
*
* @param {Cv_Extract_Form_Enum_A11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_a11 = /** @type {((inputs?: Cv_Extract_Form_Enum_A11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_A11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_a11(inputs)
	return en_cv_extract_form_enum_a11(inputs)
});
export { cv_extract_form_enum_a11 as "cv_extract_form_enum_A1" }